/*
The complete list of all patient analytics events in rivet
See RIV-3473 for rationale

Design considerations:
  * Avoid verbosity at call site. Considered too verbose: logEvent({'x', properties: {prop: 'y'}}) in comparison to logEvent('x', {prop: 'y'})
  * Make it hard to log an event that isn't explicitly enumerated here
  * Must not be directly callable from ng template expressions (to avoid loose type checking)
*/

import { Language } from '@rivethealth/data/translation';
import { SentenceCase } from '../capitalization';
import { ProcessPaymentAnalyticProperties } from './account-analytics-events';
import { EventType } from './event-types';

export const patientEventTypes: PatientEventType<any>[] = [];
export class PatientEventType<T = undefined> extends EventType<T> {
  constructor(
    readonly name: string,
    readonly description: string,
  ) {
    super(name, description);
    patientEventTypes.push(this);
  }
}

export interface PatientEstimateEventArgs {
  // We removed 'estimate id'. Feel free to expand this.
}

// ************************************************************
// List of events
// Add name + properties for new analytics events
// If possible, use one of the existing properties types (above)
// Remember to update the documentation string

// ************************************************************
// Consent
export const ChangeLanguage = new PatientEventType<{
  language: SentenceCase<Language>;
}>(
  'Change language',
  `
  * *open consent link* > *change language*
  * *open estimate link* > *change language*
  `,
);
export const SubmitPatientConsent = new PatientEventType<{
  choice: 'Accept' | 'Decline';
}>(
  'Submit patient consent',
  `
  * *open consent link* > *fill out form* > Submit
  `,
);

// ************************************************************
// Payment
export const DownloadEstimatePdf = new PatientEventType<
  PatientEstimateEventArgs & { language: SentenceCase<Language> }
>(
  'Download estimate PDF',
  `
  * *open estimate link* > Download estimate
  `,
);
export const ProcessPayment = new PatientEventType<
  ProcessPaymentAnalyticProperties & {
    'submitted by': 'Patient';
  } & PatientEstimateEventArgs
>(
  'Process payment',
  `
  * *open estimate link* > Pay now > *check understand box* > Next > Next > *fill out payment info* > Pay
  `,
);
